import { types } from "../types"


export const getDomainActionRequest = (params, id) => {
  return {
    type: types.GET_DOMAIN_REQUEST,
    params, id
  }
}

export const checkDomainActionRequest = (params) => {

  return {
    type: types.CHECK_DOMAIN_REQUEST,
    params
  }
}

export const addDomainActionRequest = (params) => {
  return {
    type: types.ADD_DOMAIN_REQUEST,
    params
  }
}
export const deleteDomainActionRequest = (params) => {
  return {
    type: types.DELETE_DOMAIN_REQUEST,
    params
  }
}

export const deactivateDomainActionRequest = (params) => {
  return {
    type: types.UPDATE_STATUS_DOMAIN_REQUEST,
    params
  }
}


export const getDomainGuidScriptAction = (domainId) => {
  return {
    type: types.GET_DOMAIN_GUID_SCRIPT_REQUEST,
    domainId
  }
}


export const resetPropsRequest = () => {
  return {
    type: types.DOMAIN_RESET_PROPS,

  }
}

export const updateDomainAddress = (params) => {
  return {
    type: types.UPDATE_DOMAIN_REQUEST,
    params

  }
}


export const setWebAddressWizard = (params) => {
  return {
    type: 'webAddressWizard',
    payload: params
  }
}

export const setUserPackageId = (params) => {
  return {
    type: 'userPackageId',
    payload: params
  }
}




